import { Button, convertToRaw, createEmptyContent, Editor } from '@arpeggi/ui'
import { FC, useState } from 'react'
import { useCreateComment } from '../../discussions-queries/queries/useCreateComment'
import { Comments } from '../primitives'

interface Props {
  discussionId: number
}

export const CreateComment: FC<Props> = ({ discussionId }) => {
  const [editorState, setEditorState] = useState(createEmptyContent())
  const createCommentMutation = useCreateComment(discussionId)

  const editorContent = editorState.getCurrentContent()
  const editorPlainText = editorContent.getPlainText()

  const handleSubmit = () => {
    createCommentMutation.mutate(
      { dto: { body: convertToRaw(editorContent) } },
      { onSuccess: () => setEditorState(createEmptyContent()) }
    )
  }

  const isSubmitDisabled = !editorPlainText.length || createCommentMutation.isLoading

  return (
    <Comments.CreateCommentContainer>
      <Editor value={editorState}>
        <Comments.CreateCommentEditor
          placeholder="Join the discussion"
          onChange={(editorState) => setEditorState(editorState)}
          maxPlainTextLength={2000}
        />
      </Editor>
      <Button size="lg" variant="success" disabled={isSubmitDisabled} onClick={handleSubmit}>
        Submit
      </Button>
    </Comments.CreateCommentContainer>
  )
}
